<template>
  <el-carousel 
    indicator-position="bottom" 
    autoplay 
    :interval="5000"
    height="1000px"
  >
    <el-carousel-item>
      <div class="carousel-item">
        <img src="@/assets/images/lunbo/xlb1.png" alt="全国领先的科技成果评估评价机构" />
        <div class="carousel-text slide1">
          <h1 class="main-title">全国领先的科技成果评估评价机构</h1>
          <div class="sub-titles">
            <span class="sub-title">概念验证</span>
            <span class="sub-title">技术尽调</span>
            <span class="sub-title">机构评估</span>
            <span class="sub-title">人才评价</span>
            <span class="sub-title">成果评价</span>
          </div>
        </div>
      </div>
    </el-carousel-item>
    <el-carousel-item>
      <div class="carousel-item">
        <img src="@/assets/images/lunbo/xlb2.png" alt="国家奖省部级奖社会力量奖奖励资讯" />
        <div class="carousel-text slide2">
          <h1 class="main-title">全国奖励资讯一手掌握</h1>
          <p class="en-title">国家奖 省部级奖 社会力量奖</p>
          <div class="sub-titles">
            <span class="sub-title">科技奖</span>
            <span class="sub-title">质量奖</span>
            <span class="sub-title">专利奖</span>
            <span class="sub-title">设计奖</span>
            <span class="sub-title">人物奖</span>
          </div>
        </div>
      </div>
    </el-carousel-item>
    <el-carousel-item>
      <div class="carousel-item">
        <img src="@/assets/images/lunbo/xlb3.png" alt="中物鉴智专家智库与成果转化服务" />
        <div class="carousel-text slide3">
          <h1 class="main-title">聚全国英才<br>筑专业智库</h1>
          <div class="sub-titles">
            <span class="sub-title">中物鉴智诚邀技术、行业、财务、投资、法律等领域专家入库</span>
           
          </div>
          <div class="bottom-text">
            <p>服务范围：项目评审 | 价值评价 | 尽职调查 | 行业咨询 | 成果转化</p>
          </div>
        </div>
      </div>
    </el-carousel-item>
  </el-carousel>
</template>

<script>
export default {
  name: 'CarouselComponent'
}
</script>

<style lang="less" scoped>
* {
  font-family: "SimHei", "Microsoft YaHei", sans-serif !important;
  font-weight: bold !important;
}

.carousel-item {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }
}

.carousel-text {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #fff;
  text-align: center;
  padding: 0 20px;
  box-sizing: border-box;
}

.main-title {
  font-size: 80px;
  margin: 0 0 30px 0;
  line-height: 1.2;
  width: 1200px;
  max-width: 90%;
  text-align-last: justify;
}

.sub-titles {
  display: flex;
  gap: 60px;
  padding: 12px 40px;
  border-top: 2px solid rgba(255,255,255,0.8);
  border-bottom: 2px solid rgba(255,255,255,0.8);
  width: 1200px;
  max-width: 90%;
  justify-content: space-around;
  margin-top: 40px;
}

.sub-title {
  font-size: 42px;
  white-space: nowrap;
}

.slide1 .main-title {
  color: #fff;
}

.slide2 .main-title {
  color: #66f0ff;
  font-size: 110px;
  width: 1100px;
  max-width: 90%;
  margin-bottom: 20px;
}

.slide2 .en-title {
  margin-bottom: 30px;
  font-size: 32px;
  width: 1100px;
  max-width: 90%;
  color: #fff;
  text-align-last: justify;
}

.slide2 .sub-titles {
  border: 4px solid rgba(255,255,255,0.8);
  gap: 50px;
  .sub-title {
    font-size: 42px !important;
  }
}

.slide3 .main-title {
  color: #66f0ff;
  font-size: 130px;
  margin-bottom: 30px;
}

.slide3 .sub-titles {
  border: none;
  gap: 50px;
  margin-bottom: 40px;
  background-color: rgba(0, 0, 0, 0.4);
  padding: 12px 40px;
  width: 1200px;
  max-width: 90%;
  justify-content: space-around;
  .sub-title {
    font-size: 34px;
    color: #fff;
  }
}

.slide3 .bottom-text p,
.endBox {
  font-size: 32px;
  margin: 8px 0;
  text-align-last: justify;
  color: #fff;
}

/* ====================== 响应式适配 ====================== */
/* 大屏笔记本 */
@media (max-width: 1200px) {
  .main-title { font-size: 60px; }
  .slide2 .main-title { font-size: 80px; }
  .slide3 .main-title { font-size: 90px; }
  .sub-title { font-size: 22px; }
  .slide2 .sub-title { font-size: 32px !important; }
  .slide3 .sub-title { font-size: 28px; }
  .slide2 .en-title,
  .slide3 .bottom-text p,
  .endBox { font-size: 26px; }
}

/* iPad 横屏 */
@media (max-width: 1024px) {
  .main-title { font-size: 50px; }
  .slide2 .main-title { font-size: 70px; }
  .slide3 .main-title { font-size: 80px; }
  .sub-titles { gap: 30px; padding: 10px 20px; }
  .sub-title { font-size: 20px; }
  .slide2 .sub-title { font-size: 28px !important; }
  .slide3 .sub-title { font-size: 24px; width: auto; }
  .slide2 .en-title,
  .slide3 .bottom-text p,
  .endBox { font-size: 24px; }
}

/* iPad 竖屏 */
@media (max-width: 768px) {
  .carousel-text { padding: 0 15px; }

  /* 轮播1 */
  .slide1 .main-title {
    font-size: 32px !important;
    width: 90% !important;
    text-align: center !important;
    text-align-last: center !important;
  }
  .slide1 .sub-titles {
    gap: 16px !important;
    padding: 8px 16px !important;
    .sub-title { font-size: 16px !important; }
  }

  /* 轮播2 */
  .slide2 .main-title {
    font-size: 32px !important;
    width: 100% !important;
    text-align: center !important;
    text-align-last: center !important;
  }
  .slide2 .en-title {
    font-size: 11px !important;
    width: 100% !important;
    letter-spacing: 0 !important;
    text-align: center !important;
    text-align-last: center !important;
    word-break: break-all;
    line-height: 1.4;
  }
  .slide2 .sub-titles {
    flex-direction: row !important;
    gap: 8px !important;
    padding: 8px 12px !important;
    border-width: 2px !important;
    width: 90% !important;
    .sub-title {
      font-size: 14px !important;
      white-space: nowrap;
    }
  }

  /* 轮播3 */
  .slide3 .main-title {
    font-size: 34px !important;
    line-height: 1.3 !important;
  }
  .slide3 .sub-titles {
    gap: 12px !important;
    padding: 8px !important;
    width: 90% !important;
    background-color: rgba(0, 0, 0, 0.4);
    .sub-title {
      font-size: 15px !important;
      width: auto !important;
      text-align: center !important;
      text-align-last: center !important;
    }
  }
  .slide3 .bottom-text p,
  .endBox {
    font-size: 16px !important;
    text-align: center !important;
    text-align-last: center !important;
    width: auto !important;
    max-width: 90% !important;
    white-space: normal !important;
    word-break: keep-all !important;
    margin: 6px 0 !important;
  }
}

/* 手机 */
@media (max-width: 480px) {
  /* 轮播1 */
  .slide1 .main-title {
    font-size: 26px !important;
  }
  .slide1 .sub-titles .sub-title {
    font-size: 14px !important;
  }

  /* 轮播2 */
  .slide2 .main-title {
    font-size: 26px !important;
  }
  .slide2 .en-title {
    font-size: 9px !important;
  }
  .slide2 .sub-titles .sub-title {
    font-size: 12px !important;
  }

  /* 轮播3 */
  .slide3 .main-title {
    font-size: 28px !important;
  }
  .slide3 .sub-titles {
    background-color: rgba(0, 0, 0, 0.4);
  }
  .slide3 .sub-titles .sub-title {
    font-size: 13px !important;
  }
  .slide3 .bottom-text p,
  .endBox {
    font-size: 14px !important;
    line-height: 1.5 !important;
  }
}
</style>